<app-form-field type="PASSWORD" [label]="'CHANGE_PASSWORD.CURRENT_PASSWORD'|translate"
                [settings]="settings.fieldsSettings.currentPassword"
                [value]="valuesForInput.currentPassword"
                (modelChange)="updateCurrentValue('currentPassword',$event)"
                [specifiedAttributes]="specifiedAttributes.currentPassword"
                (enterPressure)="submit()">
</app-form-field>
<app-form-field type="PASSWORD" [label]="'CHANGE_PASSWORD.NEW_PASSWORD'|translate"
                [settings]="settings.fieldsSettings.newPassword"
                [value]="valuesForInput.newPassword"
                (modelChange)="updateCurrentValue('newPassword',$event)"
                [specifiedAttributes]="specifiedAttributes.newPassword"
                (enterPressure)="submit()">
</app-form-field>
<app-form-field type="PASSWORD" [label]="'CHANGE_PASSWORD.NEW_PASSWORD_CONFIRMATION'|translate"
                [settings]="settings.fieldsSettings.newPasswordConfirmation"
                [value]="valuesForInput.newPasswordConfirmation"
                (modelChange)="updateCurrentValue('newPasswordConfirmation',$event)"
                [specifiedAttributes]="specifiedAttributes.newPasswordConfirmation"
                (enterPressure)="submit()">
</app-form-field>
<div class="layout horizontal space-between">
    <app-button-set align="left">
        <app-button [label]="'CANCEL'|translate" icon="arrow-left" (click)="cancel()" [disabled]="formSubmitting"></app-button>
    </app-button-set>
    <app-button-set align="right">
        <app-button [label]="'CONFIRM'|translate" primary="true" icon="check" (click)="submit()" [disabled]="someErrors || formSubmitting"></app-button>
    </app-button-set>
</div>
